import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const Trigger = ({ title = 'Trigger', ...rest }: IconProps) => (
  <BaseSvg viewBox="0 0 48 48" title={title} {...rest}>
    <path
      fill="currentColor"
      d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm-4 29V15l12 9-12 9z"
    />
  </BaseSvg>
)

Trigger.displayName = 'TriggerIcon'
export default Trigger
